module.exports = __webpack_public_path__ + "img/bg1.e0a0612f.jpg";